import axios from 'axios';

const basePath = '/web-api/cart'

export const all = (payload = null, config = {}) =>
    axios.get(
        basePath,
        config
    );

export const add = (payload, config = {}) =>
    axios.post(
        basePath,
        payload,
        config
    );

export const remove = (id, config = {}) =>
    axios.delete(
        `${basePath}/${id}`,
        config
    );

export const increase = ({ id, payload = { quantity } }, config = {}) =>
    axios.put(
        `${basePath}/${id}/increase`,
        payload,
        config
    );

export const decrease = ({ id, payload = { quantity } }, config = {}) =>
    axios.put(
        `${basePath}/${id}/decrease`,
        payload,
        config
    );

export default {
    all,
    add,
    remove,
    increase,
    decrease,
}